export enum ToasterMessages {
  Error = 'Something went wrong',

  UnderDev = 'This feature is under development and will be available soon.',
  SelectDate = 'Please select both From and To dates.',
  FormValidation = 'Please fill out all required fields.',
  FileUpload = 'File has been Uploaded successfully',
  FileWarning = 'Only Excel files are allowed',
  FileValidation = 'Please upload  File',
  ReportGenaration = 'voyage Repot has been successfully Generated. Report will be uploaded shortly',
  MonthlyReportGenaration = 'Repot has been successfully Generated. Report will be uploaded shortly',
  SubmitForm = 'Form submitted successfully',
  SubmitValidation = 'Please submit the request form. Go to "My Requests" and then come back here to generate the report.',
  PdfProcessing = 'Processing Please Wait...',
  RecordNotFount = 'Record Not Found',
  InvalidMessage = 'Invalid username or password',
  SuccessMessage = 'Status updated successfully',
  FileInput = 'FileInput updated successfully',
  VesselMissMatch = 'Uploaded file vessel name does not match the request form!',
  fileFormat = 'Uploaded file format does not match the required format!',
  FilesUpload = 'Files has been Uploaded successfully',
  DataNotFount = 'Data not found for the specified vessel IMO and voyage month',
  FormValidationLength = 'Please fill out at least two fields.',
  FORM_SUBMITTED = 'FORM_SUBMITTED',
  Update = 'Updated successfully',
  ValidationError = "ValidationError"
}
